export const getNavigationOverrides = (theme) => ({
    MuiTabs: {
      styleOverrides: {
        root: () => ({
          minHeight: "auto",
        }),
        indicator: ({ theme }) => ({
          backgroundColor: theme.palette.primary.interactive,
          width: "auto",
          height: "3px",
        }),
      },
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: "none",
          fontWeight: theme.typography.fontWeightMedium,
          fontFamily: '"Noto Sans", sans-serif',
          minWidth: 0,
          padding: theme.spacing(1, 2),
          transition: "color 0.3s ease-in-out",
          "&.Mui-selected": {
            color: theme.palette.primary.interactive,
            fontWeight: theme.typography.fontWeightBold,
          },
          "&:focus": {
            color: theme.palette.primary.interactiveHover,
          },
        }),
      },
    },
    MuiMenu: {
        styleOverrides: {
          // `tertiaryGreen` is kept LIGHT in dark mode (it doubles as a
          // light-on-green nav text token), so using it as a SURFACE here left
          // dropdowns (profile: Edit Profile / Logout) light with near-white
          // text in dark mode. Use the real dark surface token instead.
          paper: ({ theme }) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? theme.palette.background.paper
                : theme.palette.background.tertiaryGreen,
            borderRadius: "16px",
            boxShadow: theme.palette.layout.dropdownShadow,
          }),
          list: {
            padding: "8px",
          },
        },
      },
    MuiMenuItem: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: "8px",
            padding: "8px 12px",
            "&:not(:last-of-type)": {
              borderBottom: `1px solid ${theme.palette.divider}`,
            },
            "&:hover": {
              backgroundColor: theme.palette.primary.softSurface,
            },
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.softSurface,
              color: theme.palette.primary.interactive,
              fontWeight: theme.typography.fontWeightBold,
            },
            "&.Mui-selected:hover": {
              backgroundColor: theme.palette.primary.softSurface,
            },
          }),
        },
      },
    MuiLink: {
        styleOverrides: {
          root: ({ theme }) => ({
            // In dark mode the brand green (#006633) fails contrast on dark
            // surfaces, so links use the lightened accent green (text.textGreen).
            color: theme.palette.mode === "dark"
              ? theme.palette.text.textGreen
              : theme.palette.primary.main,
            "&:hover": {
              color: theme.palette.mode === "dark"
                ? theme.palette.text.secondary
                : theme.palette.primary.dark,
              textDecoration: "underline",
            },
            "&:focus-visible": {
              outline: `3px solid ${theme.palette.accent?.butterscotch }`,
              outlineOffset: "2px",
              borderRadius: "2px",
            },
          }),
        },
      },
});
